module.exports = __webpack_public_path__ + "static/media/play.7b34cb62.svg";